import React from 'react';
import { Link } from 'react-router-dom';

export default function SiteCTA() {
  return (
    <section className="py-16 bg-gestao-primary text-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center">
        <h2 className="text-2xl sm:text-3xl font-bold mb-4">
          Orçamentos grátis
        </h2>
        <p className="text-white/90 mb-8">
          Não hesite em contactar-nos. Dispomos das melhores soluções de conforto e bem-estar para si e para a sua família.
        </p>
        <Link
          to="/contactos"
          className="inline-block px-8 py-3 bg-white text-gestao-primary font-semibold rounded-xl hover:bg-slate-100 transition-colors"
        >
          Contactar
        </Link>
      </div>
    </section>
  );
}
